import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { TabLoadingState } from "@/components/entity-tabs/tab-states";
import { EntityTypePage } from "@/components/settings/entity-types/entity-type-page";
import { PageColumn, PageShell } from "@/components/ui/page-shell";
import { useOrgContext } from "@/hooks/use-org-context";
import { useEntityTypesAdmin } from "@/lib/api";
import { isSystemEntityType } from "@/lib/reserved";

export const Route = createFileRoute("/$owner/entity-types/$slug")({
	component: EditEntityTypePage,
});

function EditEntityTypePage() {
	const { owner, slug } = Route.useParams();
	const { orgContext } = useOrgContext();
	const navigate = useNavigate();
	const { data: entityTypes = [], isLoading } = useEntityTypesAdmin(orgContext);

	const entityType = entityTypes.find((et) => et.slug === slug) ?? null;
	// `$…` system types can be viewed/edited lightly but never deleted.
	const isSystemManaged = entityType ? isSystemEntityType(entityType) : false;

	return (
		<PageShell className="gap-4 pt-2.5 pb-8">
			<PageColumn>
				{isLoading ? (
					<TabLoadingState label="entity type" variant="panel" />
				) : !entityType ? (
					<div className="text-sm text-muted-foreground">
						Entity type not found.
					</div>
				) : (
					<EntityTypePage
						entityType={entityType}
						orgContext={orgContext}
						hideDelete={isSystemManaged}
						onClose={() => {
							void navigate({ to: "/$owner/data", params: { owner } });
						}}
					/>
				)}
			</PageColumn>
		</PageShell>
	);
}
